import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Device Detect
import { isMobile, isTablet } from "react-device-detect";

// Navigation
import { useNavigate, Navigate, Link } from 'react-router-dom';

// Helpers
import Helpers from '../helpers';

// Css
import '../assets/css/app.css';

// Layout
import CommerceLayout from './layouts/CommerceLayout';

// Components
import TitleDescription from '../components/TitleDescription';
import FunctionalButton from '../components/Buttons/FunctionalButton';
import ProductItem from '../components/Products/Item';

@inject('AuthStore', 'StoreStore')
@observer

class Home extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        const storeId: any = localStorage.getItem('storeId');
        const storeData = this.props.StoreStore.stores[storeId];

        return (
            storeId !== null ?
                <CommerceLayout
                    title={Helpers.translation('home')}
                >
                    {
                        this.props.StoreStore.stores[storeId].desktop_homepage.map((component: any, index: number) => {
                            const componentName = component.__component;
                            const componentStyle = isMobile || isTablet ? { marginTop: parseInt(component.mobile_top_margin), marginBottom: parseInt(component.mobile_bottom_margin) } : { marginTop: parseInt(component.desktop_top_margin), marginBottom: parseInt(component.desktop_bottom_margin) };

                            if (componentName === 'components.trainings') {
                                return (
                                    <section
                                        key={index}
                                        style={componentStyle}
                                        className="container mx-auto"
                                    >
                                        {
                                            (component.title !== null || component.description !== null) &&
                                            <TitleDescription
                                                title={component.title}
                                                description={component.description}
                                            />
                                        }

                                        <div className="relative items-center w-full mx-auto md:px-0 lg:px-0">
                                            <div className="grid w-full grid-cols-1 gap-6 mx-auto lg:grid-cols-4">
                                                {component.trainings.data.map((training: any, index: number) => {
                                                    return (
                                                        <div key={index} className="flex flex-col p-6 bg-white rounded-xl shadow-lg">
                                                            {
                                                                training.attributes.image.data !== null ?
                                                                    <img
                                                                        src={Helpers.getMediumImageUrl(training.attributes.image.data.attributes)}
                                                                        className="h-64 object-cover object-center w-full mb-8 rounded-xl"
                                                                    />
                                                                    :
                                                                    <img
                                                                        src={require("../assets/images/no-image.png")}
                                                                        className="h-64 object-cover object-center w-full mb-8 rounded-xl"
                                                                    />
                                                            }

                                                            <h2 className="mb-2 text-xs font-semibold tracking-widest text-primary uppercase">{training.attributes.title}</h2>

                                                            <p className="flex-grow text-base font-medium leading-relaxed text-gray-txt">{training.attributes.description}</p>

                                                            <div className="mt-8">
                                                                <Link
                                                                    className="flex items-center"
                                                                    to={"/trainings/" + training.id}
                                                                >
                                                                    <FunctionalButton
                                                                        text={Helpers.translation('view')}
                                                                        rounded
                                                                        fullWidth={false}
                                                                    />
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </section>
                                )
                            }

                            if (componentName === 'components.banner') {
                                const bannerData = component.banner.data.attributes;

                                return (
                                    bannerData.image.data !== null &&
                                    <section
                                        key={index}
                                        style={componentStyle}
                                        className="flex flex-col"
                                    >
                                        <div className="banner-slide relative text-center h-40 md:h-72 lg:h-96 xl:h-[600px] 2xl:h-[800px]">
                                            <img
                                                src={Helpers.getBiggestImageUrl(bannerData.image.data.attributes)}
                                                className="w-full h-full"
                                            />

                                            {
                                                (bannerData.title !== "" && bannerData.description !== "" && bannerData.button_text !== "") &&
                                                <div className="banner-content absolute bottom-[15%] left-[5%] text-left text-white p-4 bg-black bg-opacity-50 rounded-lg w-[90%] md:left-[10%] md:w-[50%]">
                                                    <h2 className="text-sm md:text-xl xl:text-2xl font-bold mb-2 md:mb-4">{bannerData.title}</h2>
                                                    <p className="mb-4 text-sm md:text-xl xl:text-2xl">
                                                        {bannerData.description}
                                                    </p>

                                                    {
                                                        bannerData.button_text !== "" &&
                                                        <Link to={bannerData.button_link}>
                                                            <FunctionalButton
                                                                text={bannerData.button_text}
                                                                rounded
                                                                fullWidth={false}
                                                            />
                                                        </Link>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </section>
                                )
                            }

                            if (componentName === 'components.products') {
                                return (
                                    <section
                                        key={index}
                                        style={componentStyle}
                                    >
                                        <div className="container mx-auto px-4">
                                            {
                                                (component.title !== null || component.description !== null) &&
                                                <TitleDescription
                                                    title={component.title}
                                                    description={component.description}
                                                />
                                            }

                                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
                                                {component.products.data.map((product: any, index: number) => {
                                                    const mainImage: any = product.attributes.main_image.data !== null ? Helpers.getMediumImageUrl(product.attributes.main_image.data.attributes) : null;
                                                    const convertCurrencyData = Helpers.convertCurrencyData({
                                                        id: product.attributes.currency.data.id,
                                                        ...product.attributes.currency.data.attributes
                                                    });
                                                    const category = product.attributes.product_categories.data.map((categoryData: any) => {
                                                        return categoryData.attributes.title;
                                                    }).join(" - ");

                                                    let price = null;
                                                    if (Helpers.getUserData().isLogin) {
                                                        price = convertCurrencyData !== null ? Helpers.returnPrice(product.id, {
                                                            price: product.attributes.price,
                                                            ...convertCurrencyData
                                                        }) : null;
                                                    } else {
                                                        if (storeData.not_login_view_price !== "not_view") {
                                                            let productPrice = null;

                                                            if (storeData.not_login_view_price === "customer_price") {
                                                                productPrice = product.attributes.customer_price;
                                                            }

                                                            if (storeData.not_login_view_price === "dealer_price") {
                                                                productPrice = product.attributes.price;
                                                            }

                                                            price = convertCurrencyData !== null ? Helpers.returnPrice(product.id, {
                                                                price: productPrice,
                                                                ...convertCurrencyData
                                                            }) : null;
                                                        }
                                                    }

                                                    return (
                                                        <ProductItem
                                                            key={index}
                                                            title={product.attributes.title}
                                                            id={product.id}
                                                            mainImage={mainImage}
                                                            category={category}
                                                            priceData={price}
                                                        />
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </section>
                                )
                            }

                            if (componentName === 'components.product-categories') {
                                return (
                                    <section
                                        key={index}
                                        style={componentStyle}
                                    >
                                        <div className="container mx-auto">
                                            {
                                                (component.title !== null || component.description !== null) &&
                                                <TitleDescription
                                                    title={component.title}
                                                    description={component.description}
                                                />
                                            }

                                            <div className="flex flex-wrap -mx-4">
                                                {component.product_categories.data.map((category: any, index: number) => {
                                                    return (
                                                        <div
                                                            key={index}
                                                            className="w-full sm:w-1/3 px-4 mb-8"
                                                        >
                                                            <div className="category-banner relative overflow-hidden rounded-lg shadow-lg group">
                                                                <div className="w-full p-2">
                                                                    {
                                                                        category.attributes.image.data !== null ?
                                                                            <img
                                                                                src={Helpers.getBiggestImageUrl(category.attributes.image.data.attributes)}
                                                                                className="w-full h-64 object-contain"
                                                                            />
                                                                            :
                                                                            <img
                                                                                src={require("../assets/images/no-image.png")}
                                                                                className="w-full h-64"
                                                                            />
                                                                    }
                                                                </div>

                                                                <div className="absolute inset-0 bg-gray-light bg-opacity-50"></div>
                                                                <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white p-4">
                                                                    <h2 className="text-2xl md:text-3xl font-bold mb-4">
                                                                        {category.attributes.title}
                                                                    </h2>

                                                                    <Link
                                                                        className="flex items-center"
                                                                        to={"/products/category/" + category.id}
                                                                    >
                                                                        <FunctionalButton
                                                                            text={Helpers.translation('view')}
                                                                            rounded
                                                                            fullWidth={false}
                                                                        />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </section>
                                )
                            }

                            if (componentName === 'components.account-numbers') {
                                return (
                                    <section
                                        key={index}
                                        style={componentStyle}
                                    >
                                        <div className="container mx-auto">
                                            {
                                                (component.title !== null || component.description !== null) &&
                                                <TitleDescription
                                                    title={component.title}
                                                    description={component.description}
                                                />
                                            }

                                            <div className="flex flex-wrap -mx-4">
                                                {component.account_numbers.data.map((accountNumber: any, index: number) => {
                                                    return (
                                                        <div
                                                            key={index}
                                                            className="w-full sm:w-1/3 px-4 mb-8"
                                                        >
                                                            <div className="relative overflow-hidden rounded-lg">
                                                                {
                                                                    accountNumber.attributes.logo.data !== null &&
                                                                    <img
                                                                        src={Helpers.getMediumImageUrl(accountNumber.attributes.logo.data.attributes)}
                                                                        className="w-full h-44 object-contain"
                                                                    />
                                                                }

                                                                <div className="font-bold">{accountNumber.attributes.title}</div>

                                                                <div>
                                                                    <span className="font-bold">{Helpers.translation('account_owner')}: </span>
                                                                    <span>{accountNumber.attributes.account_owner}</span>
                                                                </div>

                                                                <div>
                                                                    <span className="font-bold">{Helpers.translation('account_number')}: </span>
                                                                    <span>{accountNumber.attributes.account_number}</span>
                                                                </div>

                                                                <div>
                                                                    <span className="font-bold">{Helpers.translation('iban')}: </span>
                                                                    <span>{accountNumber.attributes.iban}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </section>
                                )
                            }
                        })
                    }
                </CommerceLayout>
                :
                <Navigate to="/" replace={true} />
        )
    }
}

function WithNavigate(props: any) {
    let navigate = useNavigate();
    return <Home {...props} navigate={navigate} />
}

export default WithNavigate